module.exports = __webpack_public_path__ + "db08db73ed449c84c0f489b43f37eb72.png";